export class SingletonMap {
    static update(key, obj) {
        if (SingletonMap.map.has(key)) {
            Object.assign(SingletonMap.map.get(key), obj);
        }
        else {
            SingletonMap.map.set(key, obj);
        }
    }
}
SingletonMap.map = new Map();
//# sourceMappingURL=SingletonMap.js.map